import { useAuth0 } from "@auth0/auth0-vue";

let auth0Instance = null;

// Initialize the Auth0 instance in a Vue component
export const initializeAuth0 = () => {
  auth0Instance = useAuth0();
};

// Expose getAccessTokenSilently
export const getTokenSilently = async (options = {}) => {
  if (!auth0Instance) {
    throw new Error("Auth0 has not been initialized. Call initializeAuth0 first.");
  }

  const { getAccessTokenSilently } = auth0Instance;
  return await getAccessTokenSilently(options);
};
